export type AppView = 'chat' | 'practice';

interface HeaderProps {
  modeLabel: string;
  view: AppView;
  onSetView(view: AppView): void;
  onOpenSettings(): void;
}

export function Header({ modeLabel, view, onSetView, onOpenSettings }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-brand">
        <h1 className="wordmark">SIGNPOST</h1>
        <p className="mode-label">{view === 'practice' ? 'Fingerspelling' : modeLabel}</p>
      </div>
      <div className="header-actions">
        <button
          type="button"
          className="btn-secondary"
          /* The accessible name must contain the visible label (WCAG 2.5.3),
             and the visible label is spelled the Australian way. */
          aria-label={view === 'chat' ? 'PRACTISE fingerspelling' : 'CHAT with the interpreter'}
          onClick={() => onSetView(view === 'chat' ? 'practice' : 'chat')}
        >
          {view === 'chat' ? 'PRACTISE' : 'CHAT'}
        </button>
        <button type="button" className="btn-secondary" onClick={onOpenSettings}>
          SETTINGS
        </button>
      </div>
    </header>
  );
}
